<app-home (selectedCemeteryOutput)="sendFilterCemeteryEvent($event)"></app-home>

<div class="container">
  <router-outlet></router-outlet>
</div>

<!-- <button (click)="onClickImages()">Zdjęcia</button>
<li *ngFor="let image of images">
  <img
    src="{{ url.toString() + image.toString() }}"
    alt=""
    width="200dp"
    height="200dp"
  />
</li> -->
